import Goals from "./Goals";
import { NutritionistInitialContext } from "../HistoryForm/NutritionistInitialAssessmentProvider";

const NutritionistGoalsForm = ({ form, data }) => {
  return (
    <>
      <Goals context={NutritionistInitialContext} form={form} data={data} />
    </>
  );
};

export default NutritionistGoalsForm;
